var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { store, useAppDispatch } from '../../store';
import { addWhiteboardOtherImageFile } from '../../store/slices/whiteboard';
import { sendAnalyticsByWebsocket, sendWebsocketMessage, } from '../../helpers/websocket';
import { randomString, sleep } from '../../helpers/utils';
import sendAPIRequest from '../../helpers/api/plugNmeetAPI';
import { broadcastWhiteboardOfficeFile } from './helpers/handleRequestedWhiteboardData';
import useResumableFilesUpload from '../../helpers/hooks/useResumableFilesUpload';
import useStorePreviousInt from '../../helpers/hooks/useStorePreviousInt';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../../helpers/proto/plugnmeet_datamessage_pb';
import { formatStorageKey, handleToAddWhiteboardUploadedOfficeNewFile, } from './helpers/utils';
import { AnalyticsEvents, AnalyticsEventType, } from '../../helpers/proto/plugnmeet_analytics_pb';
const UploadFilesUI = ({ refreshFileBrowser, allowedFileTypes, currentPage, excalidrawAPI, }) => {
    _react_refresh_temp_2();
    const inputFile = useRef(null);
    const [files, setFiles] = useState();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const session = store.getState().session;
    const preRefreshFileBrowser = useStorePreviousInt(refreshFileBrowser);
    const { isUploading, result } = useResumableFilesUpload({
        allowedFileTypes,
        maxFileSize: '30',
        files,
    });
    useEffect(() => {
        if (result && result.filePath) {
            postUploadTask(result.filePath, result.fileName, result.fileExtension);
        }
    }, [result]);
    useEffect(() => {
        var _a;
        if (!isUploading &&
            refreshFileBrowser > 0 &&
            preRefreshFileBrowser !== refreshFileBrowser) {
            (_a = inputFile.current) === null || _a === void 0 ? void 0 : _a.click();
        }
    }, [refreshFileBrowser, isUploading, preRefreshFileBrowser]);
    const onChange = (e) => {
        const files = e.target.files;
        if (!files.length) {
            return;
        }
        setFiles([...files]);
    };
    const postUploadTask = (filePath, fileName, fileExtension) => {
        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'svg':
                toast(t('right-panel.file-upload-success'), {
                    type: 'success',
                });
                broadcastFile(filePath, fileName);
                // send analytics
                sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_WHITEBOARD_FILES, AnalyticsEventType.USER, fileName);
                sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES, AnalyticsEventType.ROOM, fileName);
                break;
            default:
                convertFile(session, filePath);
                break;
        }
    };
    const convertFile = async (session, filePath) => {
        var _a;
        const id = toast.loading(t('whiteboard.converting'), {
            type: 'info',
        });
        const body = {
            sid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            userId: (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.userId,
            file_path: filePath,
        };
        const res = await sendAPIRequest('convertWhiteboardFile', body);
        if (!res.status) {
            toast.update(id, {
                render: t(res.msg),
                type: 'error',
                isLoading: false,
                closeButton: true,
            });
            return;
        }
        // save current page state before changes
        await saveCurrentPageData();
        // is important here, otherwise file id will be invalid
        // in handleToAddWhiteboardUploadedOfficeNewFile
        res.whiteboard_file_id = res.file_id;
        const newFile = handleToAddWhiteboardUploadedOfficeNewFile(res, excalidrawAPI.getAppState().height, excalidrawAPI.getAppState().width);
        await sleep(500);
        broadcastWhiteboardOfficeFile(newFile);
        // send analytics
        sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_USER_WHITEBOARD_FILES, AnalyticsEventType.USER, newFile.fileName);
        sendAnalyticsByWebsocket(AnalyticsEvents.ANALYTICS_EVENT_ROOM_WHITEBOARD_FILES, AnalyticsEventType.ROOM, newFile.fileName);
        toast.update(id, {
            render: t('whiteboard.file-ready'),
            type: 'success',
            isLoading: false,
            autoClose: 1000,
        });
    };
    const broadcastFile = (filePath, fileName) => {
        var _a, _b, _c, _d;
        const file = {
            id: randomString(),
            currentPage,
            filePath,
            fileName,
            uploaderWhiteboardHeight: excalidrawAPI.getAppState().height,
            uploaderWhiteboardWidth: excalidrawAPI.getAppState().width,
            isOfficeFile: false,
        };
        dispatch(addWhiteboardOtherImageFile(file));
        const files = store.getState().whiteboard.whiteboardOfficeFilePagesAndOtherImages;
        const session = store.getState().session;
        const dataMsg = new DataMessage({
            type: DataMsgType.WHITEBOARD,
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            body: {
                type: DataMsgBodyType.ADD_WHITEBOARD_FILE,
                from: {
                    sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                    userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                },
                msg: files,
            },
        });
        sendWebsocketMessage(dataMsg.toBinary());
    };
    const saveCurrentPageData = async () => {
        if (!excalidrawAPI) {
            return;
        }
        const elms = excalidrawAPI.getSceneElementsIncludingDeleted();
        if (elms.length) {
            const currentPageNumber = store.getState().whiteboard.currentPage;
            sessionStorage.setItem(formatStorageKey(currentPageNumber), JSON.stringify(elms));
        }
    };
    const render = () => {
        return (_jsx(_Fragment, { children: _jsx("input", { type: "file", id: "chat-file", ref: inputFile, style: { display: 'none' }, onChange: (e) => onChange(e), accept: allowedFileTypes.map((file) => '.' + file).join(',') }) }));
    };
    return render();
};
_react_refresh_temp_1 = UploadFilesUI;
$RefreshReg$(_react_refresh_temp_1, "UploadFilesUI");
_react_refresh_temp_2(UploadFilesUI, "+V/QpL0OFxoVW5GyDgs5nrxrsCc=", false, () => [useTranslation, useAppDispatch, useStorePreviousInt, useResumableFilesUpload]);
export default UploadFilesUI;
